<div class="detail-box">
    <ng-container class="detail-item" *ngIf="trasferimentiInIngresso && trasferimentiInIngresso.length > 0; else no_trasferimenti_in_ingresso">
        <h5 class="mt-2">Trasferimenti in ingresso</h5>
        <table aria-label="quote-table" class="table">
            <thead class="bg-light">
                <tr>
                    <th scope="col">Data effetto</th>
                    <th scope="col">Stato</th>
                    <th scope="col">Data prima iscrizione</th>
                    <th scope="col">Data iscrizione provenienza</th>
                    <th scope="col">Data uscita fondo cedente</th>
                    <th scope="col">Numero iscrizione covip</th>
                    <th scope="col">Denominazione Fondo</th>
                    <th scope="col">Importo Totale</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let trasferimento of trasferimentiInIngresso">
                    <tr>
                        <td>{{ trasferimento.effectDate | date }}</td>
                        <td>{{ trasferimento.state }}</td>
                        <td>{{ trasferimento.firstSubscriptionDate !== 'N/A' ? ( trasferimento.firstSubscriptionDate | date ) : 'N/A' }}</td>
                        <td>{{ trasferimento.originRegistrationDate !== 'N/A' ? ( trasferimento.originRegistrationDate | date ) : 'N/A' }}</td>
                        <td>{{ trasferimento.cedantFundExitDate !== 'N/A' ? ( trasferimento.cedantFundExitDate | date ) : 'N/A' }}</td>
                        <td>{{ trasferimento.covipSubscriptionNumber }}</td>
                        <td>{{ trasferimento.fundName }}</td>
                        <td>{{ trasferimento.totalAmount | currency: 'EUR' }}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </ng-container>
    <ng-template #no_trasferimenti_in_ingresso>
        <h6>Non risultano trasferimenti in ingresso.</h6>
    </ng-template>
     <ng-container class="detail-item" *ngIf="trasferimentiTecnici && trasferimentiTecnici.length > 0; else no_trasferimenti_tecnici">
        <h5 class="mt-2">Trasferimenti tecnici</h5>
        <table aria-label="quote-table" class="table">
            <thead class="bg-light">
                <tr>
                    <th scope="col">Data effetto</th>
                    <th scope="col">Stato</th>
                    <th scope="col">Data prima iscrizione</th>
                    <th scope="col">Data iscrizione provenienza</th>
                    <th scope="col">Data uscita fondo cedente</th>
                    <th scope="col">Numero iscrizione covip</th>
                    <th scope="col">Denominazione Fondo</th>
                    <th scope="col">Importo Totale</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let trasferimento of trasferimentiTecnici">
                    <tr>
                        <td>{{ trasferimento.effectDate | date }}</td>
                        <td>{{ trasferimento.state }}</td>
                        <td>{{ trasferimento.firstSubscriptionDate !== 'N/A' ? ( trasferimento.firstSubscriptionDate | date ) : 'N/A' }}</td>
                        <td>{{ trasferimento.originRegistrationDate !== 'N/A' ? ( trasferimento.originRegistrationDate | date ) : 'N/A' }}</td>
                        <td>{{ trasferimento.cedantFundExitDate !== 'N/A' ? ( trasferimento.cedantFundExitDate | date ) : 'N/A' }}</td>
                        <td>{{ trasferimento.covipSubscriptionNumber }}</td>
                        <td>{{ trasferimento.fundName }}</td>
                        <td>{{ trasferimento.totalAmount | currency: 'EUR' }}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </ng-container>
    <ng-template #no_trasferimenti_tecnici>
        <h6>Non risultano trasferimenti tecnici.</h6>
    </ng-template>
    <ng-container class="detail-item" *ngIf="trasferimentiTfr && trasferimentiTfr.length > 0; else no_trasferimenti_tfr">
        <h5 class="mt-2">Trasferimenti TFR pregresso</h5>
        <table aria-label="quote-table" class="table">
            <thead class="bg-light">
                <tr>
                    <th scope="col">Data effetto</th>
                    <th scope="col">Stato</th>
                    <th scope="col">Data prima iscrizione</th>
                    <th scope="col">Data iscrizione provenienza</th>
                    <th scope="col">Data uscita fondo cedente</th>
                    <th scope="col">Numero iscrizione covip</th>
                    <th scope="col">Denominazione Fondo</th>
                    <th scope="col">Importo Totale</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let trasferimento of trasferimentiTfr">
                    <tr>
                        <td>{{ trasferimento.effectDate | date }}</td>
                        <td>{{ trasferimento.state }}</td>
                        <td>{{ trasferimento.firstSubscriptionDate !== 'N/A' ? ( trasferimento.firstSubscriptionDate | date ) : 'N/A' }}</td>
                        <td>{{ trasferimento.originRegistrationDate !== 'N/A' ? ( trasferimento.originRegistrationDate | date ) : 'N/A' }}</td>
                        <td>{{ trasferimento.cedantFundExitDate !== 'N/A' ? ( trasferimento.cedantFundExitDate | date ) : 'N/A' }}</td>
                        <td>{{ trasferimento.covipSubscriptionNumber }}</td>
                        <td>{{ trasferimento.fundName }}</td>
                        <td>{{ trasferimento.totalAmount | currency: 'EUR' }}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </ng-container>
    <ng-template #no_trasferimenti_tfr>
        <h6>Non risultano trasferimenti TFR pregresso.</h6>
    </ng-template>
</div>
<hr>